import type { ReactNode } from 'react'
import { Moon, Sun } from 'lucide-react'
import BrandLogo from '@/components/brand-logo'
import { useTheme } from '@/utility/context/theme-context'
import styles from './style.module.css'

interface AuthLayoutProps {
  title: string
  subtitle?: string
  children: ReactNode
  footer?: ReactNode
}

const AuthLayout = ({ children, footer, subtitle, title }: AuthLayoutProps) => {
  const { theme, toggleTheme } = useTheme()

  return (
    <div className={styles.layout}>
      <button
        type="button"
        className={styles.themeToggle}
        onClick={toggleTheme}
        aria-label={theme === 'dark' ? 'Usar tema claro' : 'Usar tema escuro'}
      >
        {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
      </button>

      <div className={styles.card}>
        <BrandLogo className={styles.logo} />

        <div className={styles.intro}>
          <h1 className={styles.title}>{title}</h1>
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        </div>

        {children}

        {footer ? <div className={styles.footer}>{footer}</div> : null}
      </div>
    </div>
  )
}

export default AuthLayout
